import { useEffect, useRef, useState } from "react";
import { X, Save, FilterX, Filter } from "lucide-react";
import CustomButton from "@/components/desktop/button/CustomButton";
import AppliedBadges from "../applied/CustomAppliedBadges";
import FilterField from "./FilterField";
import styles from "./custom-filter.module.scss";

const CustomFilter = ({
	open,
	title = "Filtros",
	filters = [],
	appliedFilters,
	onChange,
	onApply,
	onClear,
	onClearOne,
	onOpen,
	onClose,
	showSave = false,
	onSave = () => {},
	customStyle = null,
}) => {
	const panelRef = useRef(null);
	const handleApplyRef = useRef(null);
	const [internalOpen, setInternalOpen] = useState(open);

	useEffect(() => {
		if (open) {
			setInternalOpen(true);
		} else {
			const t = setTimeout(() => setInternalOpen(false), 180);
			return () => clearTimeout(t);
		}
	}, [open]);

	useEffect(() => {
		const onKeyDown = (e) => {
			if (!open) return;
			if (e.key === "Escape" && onClose) onClose();
			if (e.key === "Enter") handleApplyRef.current?.();
		};
		document.addEventListener("keydown", onKeyDown);
		return () => document.removeEventListener("keydown", onKeyDown);
	}, [open, onClose]);

	const visibleFilters = filters.filter((f) => f.visible !== false);

	const valuesObj = filters.reduce((acc, f) => {
		acc[f.key] = f.value;
		return acc;
	}, {});

	const onRemoveBadge = (key) => {
		onClearOne(key);
	};

	const handleApply = () => {
		if (onApply) onApply(valuesObj);
		if (onClose) onClose();
	};
	handleApplyRef.current = handleApply;

	const handleClear = () => {
		if (onClear) onClear();
		if (onClose) onClose();
	};

	return (
		<div className={styles.wrap} style={customStyle}>
			<AppliedBadges filters={appliedFilters || filters} onRemove={onRemoveBadge} onClearAll={onClear} onOpen={onOpen} />

			{internalOpen && (
				<div className={`${styles.overlay} ${open ? styles.show : styles.hide}`}>
					<div
						ref={panelRef}
						className={`${styles.panel} ${open ? styles.panelIn : styles.panelOut}`}
						role="dialog"
						aria-modal="true"
						aria-label="Filtros"
					>
						<div className={styles.header}>
							<div className={styles.titles}>
								<h2 className={styles.title}>{title}</h2>
							</div>
							<button type="button" className={styles.close} onClick={onClose} aria-label="Cerrar filtros">
								<X size={18} />
							</button>
						</div>

						<div className={styles.content}>
							<div className={styles.grid}>
								{visibleFilters.map((filter) => (
									<FilterField key={filter.key} styles={styles} filter={filter} onChange={onChange} />
								))}
							</div>
						</div>

						<div className={styles.footer}>
							<div className={styles.footerLeft}>
								{showSave ? (
									<CustomButton variant="secondary" startIcon={<Save size={16} />} onClick={() => onSave(valuesObj)}>
										Guardar
									</CustomButton>
								) : null}
							</div>
							<div className={styles.footerRight}>
								<CustomButton variant="secondary" startIcon={<FilterX size={16} />} onClick={handleClear}>
									Limpiar
								</CustomButton>
								<CustomButton variant="primary" startIcon={<Filter size={16} />} onClick={handleApply}>
									Aplicar
								</CustomButton>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default CustomFilter;
